<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store" class="form-content">
        <div class="form-content-inner">

        <div class="form-col">
            <control type="hidden" v-model="appreciation.id" :hasError="!!errors.id" id="id"/>
        </div>

        <div class="form-col">
            <field :label="$t('appreciation.title')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                <datepicker v-model="appreciation.certificate_date" :enableTimePicker="false" name="certificate_date" :auto-apply="true"></datepicker>
            </field>
        </div>

        <div class="form-col">
            <field :label="$t('appreciation.achievement')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                <control type="text" v-model="appreciation.achievement"/>
            </field>
        </div>

        <div class="form-col">
            <field :label="$t('appreciation.expired_date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                <datepicker v-model="appreciation.expired_date" :enableTimePicker="false" name="expired_date" :auto-apply="true"></datepicker>
            </field>
        </div>

        <div class="form-col">
            <field :label="$t('appreciation.file')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                <input type="file" accept="application/pdf" v-on:change="onFileChange" class="form-control-file" id="my-file">
            </field>
        </div>

        <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
            <jb-buttons class="buttons-action-submit">
                <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
            </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Loading from 'vue-loading-overlay'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
export default {
name: 'ClassForm',
components: {
    Field,
    Control,
    JbButton,
    JbButtons,
    Loading,
    Datepicker
},
props: {
    showEdit: { Boolean },
    propClass: {
        type: Object,
        default: () => ({ empty: true })
    },
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
},
data: function () {
    return {
    }
},
emits: ['close-modal', 'submit', 'refresh-list'],
setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])
    const isLoading = ref(false)

    const toast = useToast()

    const router = useRouter()

    const errors = ref([])
    const preview = ref('')

    const str = useStore()
    const userlogin = localStorage.getItem('name')

    const appreciation = reactive({
        id: '',
        certificate_date: '',
        tmt: '',
        achievement: '',
        description: '',
        department_id: '',
        file: '',
        created_by: '',
        updated_by: ''
    })

    const customElementsForm = reactive({
        checkbox: ['lorem'],
        radio: 'one',
        is_active: [1],
        file: null
    })

    const onFileChange = async (event, evt) => {
        const file = event.target.files[0]
        if (file) {
            if (file.type !== 'application/pdf') {
                alert('Only PDF files are allowed');
                event.target.value = ''
            }
            else if (file.size > 1024 * 1024) {
                alert('File too big (> 1MB)')
                file.value = ''
            } else {
                const reader = new FileReader()
                reader.onloadend = function () {
                    preview.value = reader.result
            }
            reader.readAsDataURL(file)
            }
        } else {
            preview.value = ''
        }
    }

    const store = async () => {
        isLoading.value = true
        const url = props.showEdit ? 'employeappreciation/' + appreciation.id : 'employeappreciation';
        const method = props.showEdit ? "PUT" : "POST";

        appreciation.created_by = userlogin
        appreciation.file = preview.value
        
        console.log('appreciation', appreciation)

        const jsonData = JSON.stringify(appreciation)

        const configHeaders = {
            "content-type": "application/json",
            "Accept": "application/json"
        };

        await axios({
                method,
                url,
                data: jsonData,
                headers: configHeaders
            })
            .then(response => {
                if(response.data.is_doc > 0){
                    storeDoc(response.data.link_doc)
                } else {
                    if (response.data.success) {
                        emit('close-modal')
                        emit('refresh-list')
                        toast.success(response.data.message)
                    } else {
                        errors.value = response.data.messages
                        toast.error(response.data.messages)
                    }
                    isLoading.value = false
                }
            })
            .catch(error => {
                if (error.response) {
                    console.log(error)
                    toast.error(error.response.data.message)
                    console.log(JSON.stringify(error.request))
                } else if (error.message) {
                    console.log(error.message)
                    toast.error(error.message)
                    console.log(JSON.stringify(error.message))
                }
                isLoading.value = false
            })
    }

    // if doc academic active = true
    const storeDoc = (env) => {
        const url = 'doc-file-employee'
        const method = 'POST'

        isLoading.value = true
        const paramsData = {
            link_doc: env
        }
        const jsonData = JSON.stringify(paramsData)
        console.log('paramsData DOC', paramsData)

        const configHeaders = {
            'content-type': 'application/json',
            Accept: 'application/json'
        }

        axiosDocument({
            method,
            url,
            data: jsonData,
            headers: configHeaders
        })
        .then(response => {
            isLoading.value = false
            emit('close-modal')
            emit('refresh-list')
            toast.success(response.data.message)
        })
        .catch(error => {
            isLoading.value = false
            console.log('error', error)
        })
    }

    onBeforeMount(() => {
    })

    onMounted(() => {
        // appreciation.value =toRefs(props, 'propClass')
    })

    watchEffect(() => {
        const newobject = props.propObject;
        Object.assign(appreciation, newobject);

        if (!props.showEdit) {
            appreciation.id = null;
            appreciation.certificate_date = null;
            appreciation.tmt = null;
            appreciation.achievement = null;
            appreciation.expired_date = null;
            appreciation.file = null;
        }

        const newposition = props.propClass
        appreciation.submenu = newposition.submenu
        appreciation.ein = newposition.ein
        appreciation.employee_id = newposition.employee_id
        appreciation.nickname = newposition.nickname
    })

    return {
        titleStack,
        onFileChange,
        customElementsForm,
        mdiBallot,
        mdiCheckBold,
        router,
        appreciation,
        store,
        toast,
        userlogin,
        errors,
        isLoading
    }
},
methods: {
    clearForm () {
        this.appreciation = reactive({
            id: '',
            certificate_date: '',
            tmt: '',
            achievement: '',
            description: '',
            department_id: '',
            file: '',
            created_by: '',
            updated_by: ''
        })
    },
    onChange: function (department_id, event) {
        if (event.target.value) {
            department_id = event.target.value
        }
        this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
        this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
    }
},
created () {
    this.levelListFilter = this.levelList
    this.academicYearListFilter = this.academicYearList
}
}
</script>
